import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Authentification } from 'src/app/Models/Authentification';
import { TokenStorageService } from 'src/app/Services/TokenStorage/token-storage.service';
import { UserService } from 'src/app/Services/User/user.service';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { User } from 'src/app/Models/User';
@Component({
  selector: 'app-authentification',
  templateUrl: './authentification.component.html',
  styleUrls: ['./authentification.component.scss']
})
export class AuthentificationComponent implements OnInit {

  form: any;
  hide = true;
  user: any = {};
  msg = '';
  hideMsg = true;
  faEye = faEye;

  constructor(
    private http: HttpClient,
    private userservice: UserService,
    private tokenstorage: TokenStorageService,
    private router: Router
  ) { }

  ngOnInit() {
    const rememberMe = localStorage.getItem('rememberMe') === 'true';
    if (rememberMe) {
      this.user.email = localStorage.getItem('email');
      this.user.rememberMe = rememberMe;
    }
  }

  signIn() {
    
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    this.http.post<User>('http://localhost:9091/User/signin2', JSON.stringify(this.user), httpOptions)
      .subscribe(
        data => {
          
          this.user = data;
          console.log(data);
          if (this.user.rememberMe) {
            localStorage.setItem('rememberMe', this.user.rememberMe);
            localStorage.setItem('email', this.user.email);
          } else {
            localStorage.removeItem('rememberMe');
            localStorage.removeItem('email');
          }
          this.tokenstorage.saveId(this.user.id);
          this.tokenstorage.saveRoles(this.user.roles);
          this.tokenstorage.saveToken(this.user.accessToken);
          this.tokenstorage.saveProfileImage(this.user.profileImage);
          this.tokenstorage.saveClass(this.user.class);
          this.tokenstorage.saveInstitut(this.user.institut);
          this.router.navigate(['/home']);
        },
        error => {
          this.hideMsg = false;
          this.msg = "email or password are incorrect or you account need to verify by admin";
        }
      );
  }
}
